<template>
  <div>
    <p>
      The effective isotropic radiated power
      <katex-element expression="\mathrm{EIRP}" /> is given (in
      <katex-element expression="dBW" />) by:
    </p>
    <p>
      <katex-element expression="\mathrm{EIRP} = P_t - L_{L,t} + G_t" />
    </p>
    <p>where:</p>
    <ul>
      <li>
        <katex-element expression="P_t" /> is the transmitted power
        (<katex-element expression="dBW" />);
      </li>
      <li>
        <katex-element expression="L_{L,t}" /> is the transmitter transmission
        line loss (<katex-element expression="dB" />);
      </li>
      <li>
        <katex-element expression="G_t" /> is the transmitter antenna gain
        (<katex-element expression="dB" />);
      </li>
    </ul>
    <br />
  </div>
</template>

<script>
export default {
  name: 'tooltipEquationEIRP'
}
</script>
